import { Injectable } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ControlVehiculosService {

    //private filtroForm = new Subject<any>(); //Valor modificado para cargar el componente

    // Perfil actual compartido
    public perfilActual: any = null;
    private perfilActualObs = new Subject<any>();

    // NUEVO: Observable específico para recargar eventos
    private recargarEventosObs = new Subject<boolean>();

    // NUEVO: Tipo de configuración actual (eventos, paradas, informe-completo)
    public tipoConfiguracion: string = 'eventos';

    public geocercaConfig = null; //Valor Inicial para cargar el componente
    private geocercaConfigObs = new Subject<any>(); //Valor modificado para cargar el componente

    public eventosConfig = null; //Valor Inicial para cargar el componente
    private eventosConfigObs = new Subject<any>(); //Valor modificado para cargar el componente

    public mantenimientoConfig = null; //Valor Inicial para cargar el componente
    private mantenimientoConfigObs = new Subject<any>(); //Valor modificado para cargar el componente

    public VehiculosConfig = null; //Valor Inicial para cargar el componente
    private VehiculosConfigObs = new Subject<any>(); //Valor modificado para cargar el componente

    public SinTransmitirConfig = null; //Valor Inicial para cargar el componente
    private SinTransmitirConfigObs = new Subject<any>(); //Valor modificado para cargar el componente

    public MovimientoConfig = null; //Valor Inicial para cargar el componente
    private MovimientoConfigObs = new Subject<any>(); //Valor modificado para cargar el componente

    public RutasConfig = null; //Valor Inicial para cargar el componente
    private RutasConfigObs = new Subject<any>(); //Valor modificado para cargar el componente

    //public firstFiltroForm; //Valor Inicial al cargar el componente
    qs = require('qs');

    constructor(
        private gtp: Gtp,
        private http: HttpClient
    ) { }


    //PERFILES
            /**
         * Devuelve el listado de perfiles
         */
            getListaPerfiles() {
                //let urlFilter = this.qs.stringify(filter);
                return this.http.get(`${environment.baseUrl}admin/vehiculos/perfiles`);
            }
            /**
         * Devuelve el perfiles solicitado
         */
            getPerfil(idperfil) {
                //let urlFilter = this.qs.stringify(filter);
                return this.http.get(`${environment.baseUrl}admin/vehiculos/perfiles/${idperfil}`);
            }
            /**
         * Crea un perfil
         */
            savePerfil(filtro) {
                var filter = {
                    destinatarios: filtro.destinatarios,
                    eventos: filtro.eventos,
                    geocercas: filtro.geocercas,
                    mantenimiento: filtro.mantenimiento,
                    nombre: filtro.nombre,
                    sintransmitir: filtro.sintransmitir,
                    vehiculos: filtro.vehiculos,
                    movimiento: filtro.movimiento,
                }
                return this.http.post(`${environment.baseUrl}admin/vehiculos/perfiles`, filter);
            }
            //Elimina valores vacíos
            cleanMantenimiento(obj){
                // Verificar si obj existe y no es null/undefined
                if (!obj || typeof obj !== 'object') {
                    return [];
                }

                if (!obj.ultmant) { delete obj.ultmant; }
                if (!obj.kmactual) { delete obj.kmactual; }
                if (!obj.avisoxkmantes) { delete obj.avisoxkmantes; }
                if (!obj.automcada || obj.automcada == '') { delete obj.automcada; }
                return (obj.length == 0) ? [] : obj;
            }
            cleanMovimiento(obj){
                // Verificar si obj existe y no es null/undefined
                if (!obj || typeof obj !== 'object') {
                    return [];
                }

                if (!obj.intervalonotif || obj.intervalonotif == 0) { delete obj.intervalonotif; }
                if (!obj.sinidentificacion || obj.sinidentificacion == 0) { delete obj.sinidentificacion; }
                return (obj.length == 0) ? [] : obj;
            }
            /**
         * Actualiza un perfil
         */
            updatePerfil(filtro) {
                console.log('🔧 updatePerfil llamado con:', filtro);

                var filter = {
                    destinatarios: filtro.destinatarios || [],
                    eventos: filtro.eventos || [],
                    geocercas: filtro.geocercas || [],
                    mantenimiento: this.cleanMantenimiento(filtro.mantenimiento || []),
                    sintransmitir: filtro.sintransmitir || [],
                    vehiculos: filtro.vehiculos || [],
                    movimiento: this.cleanMovimiento(filtro.movimiento || []),
                    rutas: filtro.rutas || [],
                    perfil: {
                        cod_cliente: filtro.perfil?.cod_cliente || null,
                        id_perfil: filtro.perfil?.id_perfil || null,
                        nombre: filtro.perfil?.nombre || 'Sin nombre'
                    }
                }

                console.log('📤 Datos a enviar al servidor:', filter);

                return this.http.put(`${environment.baseUrl}admin/vehiculos/perfiles/${filtro.perfil.id_perfil}`, filter);
            }
            /**
         * Eliminar un perfil
         */
            removePerfil(perfil_id) {
                return this.http.delete(`${environment.baseUrl}admin/vehiculos/perfiles/${perfil_id}`);
            }

    //DESTINATARIOS
            /**
         * Devuelve el listado de destinatarios
         */
            getListaDestinatarios() {
                return this.http.get(`${environment.baseUrl}admin/vehiculos/destinatarios`);
            }
    //CONTROL GEOCERCA
            /**
         * Devuelve las configuraciones de geocerca
         */
            getGeocercaConfig() {
                return this.http.get(`${environment.baseUrl}admin/vehiculos/perfiles`);
            }
            getGeocercaConfigObs() {
                return this.geocercaConfigObs.asObservable();
            }
            setGeocercaConfig(config) {
                this.geocercaConfigObs.next(config);
            }

    //LISTA DE EVENTOS
            getListaEventos() {
                return this.http.get(`${environment.baseUrl}admin/vehiculos/eventos`);
            }
            getListaEventosConfigObs() {
                return this.eventosConfigObs.asObservable();
            }
            setEventosConfig(config) {
                this.eventosConfigObs.next(config);
            }

    //CONFIGURACIÓN DE EVENTOS
            /**
             * Guarda eventos en formato array optimizado
             */
            guardarConfiguracionEventos(datos) {
                return this.http.post(`${environment.baseUrl}admin/vehiculos/eventos/configuracion`, datos);
            }

            /**
             * Obtiene la configuración de eventos de un perfil específico
             */
            getConfiguracionEventosPerfil(idPerfil) {
                return this.http.get(`${environment.baseUrl}admin/vehiculos/perfiles/${idPerfil}`);
            }

    //CONTROL DE MOVIMIENTO
            getMovimientoConfigObs() {
                return this.MovimientoConfigObs.asObservable();
            }
            setMovimientoConfig(config) {
                this.MovimientoConfigObs.next(config);
            }
    //CONTROL DE MANTENIMIENTO
            getMantenimientoConfigObs() {
                return this.mantenimientoConfigObs.asObservable();
            }
            setMantenimientoConfig(config) {
                this.mantenimientoConfigObs.next(config);
            }
    //LISTA DE VEHICULOS
            getVehiculosConfigObs() {
                return this.VehiculosConfigObs.asObservable();
            }
            setVehiculosConfig(config) {
                this.VehiculosConfigObs.next(config);
            }
    //SIN TRANSMITIR
            getSinTransmitirConfigObs() {
                return this.SinTransmitirConfigObs.asObservable();
            }
            setSinTransmitirConfig(config) {
                this.SinTransmitirConfigObs.next(config);
            }
    //RUTAS
            getRutasConfigObs() {
                return this.RutasConfigObs.asObservable();
            }
            setRutasConfig(config) {
                this.RutasConfigObs.next(config);
            }

    //PERFIL ACTUAL
            getPerfilActualObs() {
                return this.perfilActualObs.asObservable();
            }
            setPerfilActual(perfil) {
                console.log('🔧 setPerfilActual llamado con:', perfil);
                this.perfilActual = perfil;
                this.perfilActualObs.next(perfil);
                console.log('📡 perfilActualObs.next() ejecutado');
            }
            getPerfilActual() {
                if (!this.perfilActual) {
                    return null;
                }

                // Si perfilActual tiene la estructura completa (configPerfil)
                if (this.perfilActual.perfil) {
                    // Crear objeto híbrido que es compatible con ambos usos
                    const perfilCompatible = {
                        // Propiedades del perfil directas (para compatibilidad con eventos)
                        id_perfil: this.perfilActual.perfil.id_perfil,
                        nombre: this.perfilActual.perfil.nombre,
                        cod_cliente: this.perfilActual.perfil.cod_cliente,

                        // Estructura completa (para componente de destinatarios)
                        perfil: this.perfilActual.perfil,
                        destinatarios: this.perfilActual.destinatarios || [],
                        vehiculos: this.perfilActual.vehiculos || [],
                        eventos: this.perfilActual.eventos || [],
                        geocercas: this.perfilActual.geocercas || [],
                        mantenimiento: this.perfilActual.mantenimiento || [],
                        sintransmitir: this.perfilActual.sintransmitir || [],
                        rutas: this.perfilActual.rutas || []
                    };

                    return perfilCompatible;
                }

                // Si perfilActual es solo el objeto perfil (formato anterior)
                return this.perfilActual;
            }

    //RECARGA DE EVENTOS
            /**
             * Observable para notificar cuando se debe recargar la configuración de eventos
             */
            getRecargarEventosObs() {
                return this.recargarEventosObs.asObservable();
            }

            /**
             * Notifica que se debe recargar la configuración de eventos
             */
            notificarRecargaEventos() {
                console.log('🔔 Servicio: Notificando recarga de eventos');
                this.recargarEventosObs.next(true);
            }

    //CONFIGURACIÓN DE PARADAS E INFORME COMPLETO
            /**
             * Obtiene la configuración de paradas e informe completo de un perfil específico
             */
            getConfiguracionParadasInforme(idPerfil: number) {
                return this.http.get(`${environment.baseUrl}admin/vehiculos/paradas-informe/${idPerfil}`);
            }

            /**
             * Actualiza la configuración de paradas e informe completo de un perfil
             */
            actualizarParadasInforme(idPerfil: number, datos: any) {
                return this.http.put(`${environment.baseUrl}admin/vehiculos/paradas-informe/${idPerfil}`, datos);
            }
}
